import * as jsfeat from './jsfeat';

export function getHoughPoints(
  sourceCanvas,
  angleShifts,
  maxEdges,
  acceptPoints
) {
  //document.body.appendChild(sourceCanvas);
  let imageWidth = sourceCanvas.width;
  let imageHeight = sourceCanvas.height;

  let sourceCtx = sourceCanvas.getContext('2d');
  let imageData = sourceCtx.getImageData(0, 0, imageWidth, imageHeight);

  /*
  let tmpCanvas = document.createElement('canvas');
  tmpCanvas.setAttribute('style', sourceCanvas.getAttribute('style'));
  tmpCanvas.width = imageWidth;
  tmpCanvas.height = imageHeight; // 250px max

  let tmpCtx = tmpCanvas.getContext('2d');
  tmpCtx.putImageData(sourceImageData, 0, 0);
  tmpCanvas.id = 'source';

  // jsfeat: grayscale, blur and canny edge
  let imageData = tmpCtx.getImageData(0, 0, imageWidth, imageHeight);
  */

  let options = {
    blur_radius: 3,
    low_threshold: 20,
    high_threshold: 30
  };

  let radius = options.blur_radius | 0;
  let kernel_size = (radius + 1) << 1;

  // Edges from several views of the image: brightness, brightness with
  // stretched highlights (light paper on a light table) and yellow-blue tint
  // (white paper vs. a table of similar brightness). Per pixel the strongest
  // gradient wins, then a single canny runs on it, so the views add edges
  // without doubling them.
  let img_u8 = new jsfeat.matrix_t(imageWidth, imageHeight, jsfeat.U8C1_t);
  let gradient = fuseGradients(imageData.data, kernel_size);
  cannyFromGradient(
    gradient,
    options.low_threshold,
    options.high_threshold,
    img_u8.data
  );

  // render black&white result back to canvas
  let data_u32 = new Uint32Array(imageData.data.buffer);
  let alpha = 0xff << 24;
  let i = img_u8.cols * img_u8.rows,
    pix = 0;
  while (--i >= 0) {
    pix = img_u8.data[i];
    data_u32[i] = alpha | (pix << 16) | (pix << 8) | pix;
  }

  //***********************************************************************************

  let ANGLE_AMOUNT = 360;
  let INPUT_WIDTH = imageWidth;
  let HALF_INPUT_WIDTH = INPUT_WIDTH / 2;
  let INPUT_HEIGHT = imageHeight;
  let HALF_INPUT_HEIGHT = INPUT_HEIGHT / 2;
  let RHO_MAX = Math.sqrt(
    INPUT_WIDTH * INPUT_WIDTH + INPUT_HEIGHT * INPUT_HEIGHT
  );

  // Precalculate tables.
  let cosTable = new Array(ANGLE_AMOUNT);
  let sinTable = new Array(ANGLE_AMOUNT);
  for (
    let theta = 0, thetaIndex = 0;
    thetaIndex < ANGLE_AMOUNT;
    theta += Math.PI / ANGLE_AMOUNT, thetaIndex++
  ) {
    cosTable[thetaIndex] = Math.cos(theta);
    sinTable[thetaIndex] = Math.sin(theta);
  }

  let ictx; //is sourceCtx, need for debug

  let ictx_getImageData = function(x, y) {
    if (x < 0 || y < 0 || x >= INPUT_WIDTH || y >= INPUT_HEIGHT) return 0;
    return imageData.data[4 * (x + INPUT_WIDTH * y)];
  };

  let checkMatrix = [
    [-1, -1],
    [0, -1],
    [1, -1],
    [-1, 0],
    [0, 0],
    [1, 0],
    [-1, 1],
    [0, 1],
    [1, 1]
  ];

  // noinspection JSUnusedLocalSymbols
  // eslint-disable-next-line no-unused-vars
  let checkNear = function(ix, iy, getPixel, val) {
    let result = false;
    checkMatrix.map(([x, y]) => (result |= getPixel(ix + x, iy + y) > val));
    return result;
  };

  //ictx.lineWidth = 10; // do not delete this line

  let accum = new Array(ANGLE_AMOUNT);

  let padX = Math.round(INPUT_WIDTH / 30);
  let padY = Math.round(INPUT_HEIGHT / 30);

  for (let ix = INPUT_WIDTH - padX; ix > padX; ix--) {
    for (let iy = INPUT_HEIGHT - padY; iy > padY; iy--) {
      if (ictx_getImageData(ix, iy) > 10) {
        houghAcc(ix, iy, +1);
      }
    }
  }
  for (let angleShift of angleShifts) {
    let hBottomLines = [];
    let hTopLines = [];
    let vLeftLines = [];
    let vRightLines = [];

    let bot1 = 60 + angleShift;
    let bot2 = 120 + angleShift;
    let leftAngle = 160 + angleShift;
    let rightAngle = 30 + angleShift;
    let saveMax = maxEdges ? maxEdges : 5;

    let max_a_bot = new Array(saveMax).fill(0),
      max_a_right = new Array(saveMax).fill(0),
      max_a_top = new Array(saveMax).fill(0),
      max_a_left = new Array(saveMax).fill(0);
    let max_r_bot = new Array(saveMax).fill(0),
      max_r_right = new Array(saveMax).fill(0),
      max_r_top = new Array(saveMax).fill(0),
      max_r_left = new Array(saveMax).fill(0);
    let max_v_bot = new Array(saveMax).fill(0),
      max_v_right = new Array(saveMax).fill(0),
      max_v_top = new Array(saveMax).fill(0),
      max_v_left = new Array(saveMax).fill(0);
    let setMax = (arr, val) => {
      arr.shift();
      arr.push(val);
    };

    for (let ia = ANGLE_AMOUNT; ia--; ) {
      let angle = (ia / ANGLE_AMOUNT) * 180;
      if (angle >= bot1 && angle <= bot2) {
        for (let ir in accum[ia]) {
          ir = ir | 0;
          if (ir > RHO_MAX * 2) {
            if (accum[ia][ir] > max_v_bot[saveMax - 1]) {
              setMax(max_a_bot, ia);
              setMax(max_r_bot, ir);
              setMax(max_v_bot, accum[ia][ir]);
            }
          } else {
            if (accum[ia][ir] > max_v_top[saveMax - 1]) {
              setMax(max_a_top, ia);
              setMax(max_r_top, ir);
              setMax(max_v_top, accum[ia][ir]);
            }
          }
        }
      } else if (angle <= rightAngle) {
        for (let ir in accum[ia]) {
          ir = ir | 0;
          if (ir > RHO_MAX * 2) {
            if (accum[ia][ir] > max_v_right[saveMax - 1]) {
              setMax(max_a_right, ia);
              setMax(max_r_right, ir);
              setMax(max_v_right, accum[ia][ir]);
            }
          } else {
            if (accum[ia][ir] > max_v_left[saveMax - 1]) {
              setMax(max_a_left, ia);
              setMax(max_r_left, ir);
              setMax(max_v_left, accum[ia][ir]);
            }
          }
        }
      } else if (angle >= leftAngle) {
        for (let ir in accum[ia]) {
          ir = ir | 0;
          if (ir > RHO_MAX * 2) {
            if (accum[ia][ir] > max_v_left[saveMax - 1]) {
              setMax(max_a_left, ia);
              setMax(max_r_left, ir);
              setMax(max_v_left, accum[ia][ir]);
            }
          } else {
            if (accum[ia][ir] > max_v_right[saveMax - 1]) {
              setMax(max_a_right, ia);
              setMax(max_r_right, ir);
              setMax(max_v_right, accum[ia][ir]);
            }
          }
        }
      }
    }

    let r = calcR(max_r_bot[saveMax - 1]);
    while (max_v_bot.length) {
      makeLine(
        max_v_bot.pop(),
        max_a_bot.pop(),
        max_r_bot.pop(),
        hBottomLines,
        false,
        'red'
      );
    }
    if (!hBottomLines.length) {
      hBottomLines.push(new Line(0, r, INPUT_WIDTH, INPUT_HEIGHT + r, ictx));
    }

    r = calcR(max_r_right[saveMax - 1]);
    while (max_v_right.length) {
      makeLine(
        max_v_right.pop(),
        max_a_right.pop(),
        max_r_right.pop(),
        vRightLines,
        true,
        'green'
      );
    }
    if (!vRightLines.length) {
      vRightLines.push(
        new Line(
          HALF_INPUT_WIDTH + r,
          0,
          HALF_INPUT_WIDTH + r,
          INPUT_HEIGHT,
          ictx,
          'green'
        )
      );
    }

    r = calcR(max_r_top[saveMax - 1]);
    while (max_v_top.length) {
      makeLine(
        max_v_top.pop(),
        max_a_top.pop(),
        max_r_top.pop(),
        hTopLines,
        true,
        'yellow'
      );
    }
    if (!hTopLines.length) {
      hTopLines.push(
        new Line(0, r, INPUT_WIDTH, INPUT_HEIGHT + r, ictx, 'yellow')
      );
    }

    r = calcR(max_r_left[saveMax - 1]);
    while (max_v_left.length) {
      makeLine(
        max_v_left.pop(),
        max_a_left.pop(),
        max_r_left.pop(),
        vLeftLines,
        true,
        'blue'
      );
    }
    if (!vLeftLines.length) {
      vLeftLines.push(
        new Line(
          HALF_INPUT_WIDTH + r,
          0,
          HALF_INPUT_WIDTH + r,
          INPUT_HEIGHT,
          ictx,
          'blue'
        )
      );
    }

    let allPointsMode = true;
    let rectangles = [];
    do {
      let topPoints = getIntersectionpoints(
        hTopLines,
        vLeftLines,
        vRightLines,
        allPointsMode
      );
      let bottomPoints = getIntersectionpoints(
        hBottomLines,
        vLeftLines,
        vRightLines,
        allPointsMode
      );

      for (let i = 0; i < topPoints.length; i++) {
        for (let j = 0; j < bottomPoints.length; j++) {
          rectangles.push(
            calculateSurface(
              topPoints[i][0],
              topPoints[i][1],
              bottomPoints[j][1],
              bottomPoints[j][0]
            )
          );
        }
      }

      rectangles.sort((b, a) => parseFloat(a.surface) - parseFloat(b.surface));

      if (
        !allPointsMode &&
        (!rectangles[0] ||
          (rectangles[0].surface * 100) / (INPUT_WIDTH * INPUT_HEIGHT) < 10)
      ) {
        rectangles = [];
        allPointsMode = true;
      } else {
        allPointsMode = false;
      }
    } while (allPointsMode);

    rectangles.sort((b, a) => parseFloat(a.surface) - parseFloat(b.surface));

    if (rectangles[0] && acceptPoints(rectangles[0].rctPoints)) {
      return rectangles[0].rctPoints;
    }
  }
  return false;

  //functions
  //------------------------------------------------------------------------------------------------------

  // Blurred sobel gradient of each view; keeps the strongest |dx|+|dy| per pixel
  function fuseGradients(rgba, blurKernelSize) {
    let n = imageWidth * imageHeight;
    let gx = new Int32Array(n),
      gy = new Int32Array(n),
      mag = new Int32Array(n);
    let view = new jsfeat.matrix_t(imageWidth, imageHeight, jsfeat.U8C1_t);
    let dxdy = new jsfeat.matrix_t(imageWidth, imageHeight, jsfeat.S32C2_t);

    let addView = fill => {
      fill(view.data);
      jsfeat.imgproc.gb(view, view, blurKernelSize, 0);
      jsfeat.imgproc.sobel_derivatives(view, dxdy);
      let d = dxdy.data;
      for (let p = 0; p < n; p++) {
        let x = d[2 * p],
          y = d[2 * p + 1],
          m = Math.abs(x) + Math.abs(y);
        if (m > mag[p]) {
          mag[p] = m;
          gx[p] = x;
          gy[p] = y;
        }
      }
    };

    let gray = () => jsfeat.imgproc.gs(rgba, imageWidth, imageHeight, view);
    addView(gray);
    addView(data => {
      gray();
      for (let p = 0; p < n; p++) {
        data[p] = Math.round(255 * Math.pow(data[p] / 255, 3));
      }
    });
    addView(data => {
      for (let p = 0; p < n; p++) {
        let yb = 128 + (rgba[4 * p] + rgba[4 * p + 1]) / 2 - rgba[4 * p + 2];
        data[p] = yb < 0 ? 0 : yb > 255 ? 255 : yb;
      }
    });

    return { gx, gy, mag };
  }

  // Canny without the gradient step: non-maximum suppression and hysteresis
  function cannyFromGradient({ gx, gy, mag }, low, high, out) {
    let w = imageWidth,
      h = imageHeight;
    let mark = new Uint8Array(w * h);
    let stack = [];
    for (let y = 1; y < h - 1; y++) {
      for (let x = 1; x < w - 1; x++) {
        let p = y * w + x,
          m = mag[p];
        if (m <= low) continue;
        let ax = Math.abs(gx[p]),
          ay = Math.abs(gy[p]);
        let a, b;
        if (ay <= ax * 0.4142) {
          [a, b] = [mag[p - 1], mag[p + 1]];
        } else if (ay >= ax * 2.4142) {
          [a, b] = [mag[p - w], mag[p + w]];
        } else if (gx[p] * gy[p] > 0) {
          [a, b] = [mag[p - w - 1], mag[p + w + 1]];
        } else {
          [a, b] = [mag[p - w + 1], mag[p + w - 1]];
        }
        if (m > a && m >= b) {
          mark[p] = m > high ? 2 : 1;
          if (mark[p] === 2) stack.push(p);
        }
      }
    }
    let neighbours = [-w - 1, -w, -w + 1, -1, 1, w - 1, w, w + 1];
    while (stack.length) {
      let p = stack.pop();
      for (let o of neighbours) {
        if (mark[p + o] === 1) {
          mark[p + o] = 2;
          stack.push(p + o);
        }
      }
    }
    for (let p = 0; p < out.length; p++) out[p] = mark[p] === 2 ? 255 : 0;
  }

  // Implementation with lookup tables.
  function houghAcc(x, y, v) {
    let rho;
    x -= HALF_INPUT_WIDTH;
    y -= HALF_INPUT_HEIGHT;

    for (let thetaIndex = 0; thetaIndex < ANGLE_AMOUNT; thetaIndex++) {
      rho = RHO_MAX + x * cosTable[thetaIndex] + y * sinTable[thetaIndex];
      rho = (rho * 2) | 0;
      if (accum[thetaIndex] === undefined) accum[thetaIndex] = [];
      if (accum[thetaIndex][rho] === undefined) {
        accum[thetaIndex][rho] = 1 * v;
      } else {
        accum[thetaIndex][rho] += 1 * v;
      }
    }
  }

  function calcR(from, vert) {
    let max = vert ? HALF_INPUT_WIDTH : HALF_INPUT_HEIGHT;

    let r = from / 2 - RHO_MAX;
    return Math.abs(r) > max ? (max - max / 3) * Math.sign(r) : r;
  }

  function makeLine(max_v, max_a, max_r, toArray, hor, color) {
    if (max_v > 0) {
      let r = calcR(max_r, hor);
      max_a /= 2;
      if (max_a !== 0) {
        let angle = (max_a / 180) * Math.PI;
        let y1 = HALF_INPUT_HEIGHT + r / Math.sin(angle);
        let y2 = HALF_INPUT_WIDTH / Math.tan(angle);
        toArray.push(
          new Line(
            0,
            Math.round(y1 + y2),
            INPUT_WIDTH,
            Math.round(y1 - y2),
            ictx,
            color
          )
        );
      }
    }
  }

  // Determine the intersection point of two line segments
  // Return FALSE if the lines don't intersect
  function intersectLine(line1, line2) {
    return intersect(
      line1.x1,
      line1.y1,
      line1.x2,
      line1.y2,
      line2.x1,
      line2.y1,
      line2.x2,
      line2.y2
    );
  }

  function intersect(x1, y1, x2, y2, x3, y3, x4, y4) {
    // Check if none of the lines are of length 0
    if ((x1 === x2 && y1 === y2) || (x3 === x4 && y3 === y4)) {
      return false;
    }

    let denominator = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);

    // Lines are parallel
    if (denominator === 0) {
      return false;
    }

    let ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator;
    let ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denominator;

    // is the intersection along the segments
    if (ua < 0 || ua > 1 || ub < 0 || ub > 1) {
      return false;
    }

    // Return a object with the x and y coordinates of the intersection
    let x = x1 + ua * (x2 - x1);
    let y = y1 + ua * (y2 - y1);

    return new Point(Math.round(x), Math.round(y));
  }

  function getIntersectionpoints(lineOrt, linePar1, linePar2, allPointsMode) {
    let pointAry = [];
    let checkPoints = tempResult =>
      tempResult.x < INPUT_WIDTH - 3 &&
      tempResult.x > 3 &&
      tempResult.y < INPUT_HEIGHT - 3 &&
      tempResult.y > 3;

    for (let i = 0; i < lineOrt.length; i++) {
      for (let j = 0; j < (i === 0 ? linePar1.length : 1); j++) {
        for (let k = 0; k < (i === 0 ? linePar2.length : 1); k++) {
          let p1 = intersectLine(lineOrt[i], linePar1[j]);
          let p2 = intersectLine(lineOrt[i], linePar2[k]);

          // remove unlikely and negative intersection points for speed up
          if (p1 && p2 && checkPoints(p1) && checkPoints(p2)) {
            pointAry.push([p1, p2]);
            if (!allPointsMode) {
              return pointAry;
            }
          }
        }
      }
    }
    return pointAry;
  }

  // ( (X1Y2 - Y1X2) + (X2Y3 - Y2X3)+...(XxY1-YyX1) ) / 2 = polygon's area (clockwise!)
  function calculateSurface(topLeft, topRight, bottomRight, bottomLeft) {
    let vertices = [topLeft, topRight, bottomRight, bottomLeft];
    let total = 0;
    for (let i = 0, l = vertices.length; i < l; i++) {
      let addX = vertices[i].x;
      let addY = vertices[i === vertices.length - 1 ? 0 : i + 1].y;
      let subX = vertices[i === vertices.length - 1 ? 0 : i + 1].x;
      let subY = vertices[i].y;

      total += addX * addY * 0.5;
      total -= subX * subY * 0.5;
    }

    return new Rectangle(Math.abs(total), vertices);
  }

  function Rectangle(surface, vertice) {
    this.surface = surface;
    this.rctPoints = vertice;
  }

  function Point(x, y) {
    this.x = x;
    this.y = y;
  }

  function Line(x1, y1, x2, y2, ctx, color) {
    this.x1 = x1;
    this.y1 = y1;
    this.x2 = x2;
    this.y2 = y2;

    /*if (0 && ctx) {
      color = color ? color : 'red';
      ctx.strokeStyle = color;
      ctx.lineWidth = 2;

      ctx.beginPath();
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.stroke();
    }*/
  }
}
